import Chapter from 'components/Chapter';
import SliceChart from 'components/SliceChart';
import ChartTitle from 'components/ChartTitle';
import RadialChart from 'components/RadialChart';
import TextComparison from 'components/TextComparison';
import LookCloser from 'components/LookCloser';
import EmojiGraphFaded from 'components/EmojiGraphFaded';
import EmojiWordsGraph from 'components/EmojiWordsGraph';
import InView from 'components/InView';

const PersonalityChanges = ({ copy }) => (
	<Chapter
		section={4}
		title={copy.personalityChangesTitle}
		standFirst={copy.personalityChangesStandfirst}
		highlight={['52%']}
	>
		<ChartTitle tag="p">{copy.personalityChangesText1}</ChartTitle>

		<ChartTitle tag="p">{copy.personalityChangesText2}</ChartTitle>

		<p>{copy.personalityChangesViz1Title}</p>

		<TextComparison
			snugPadding
			items={copy.personalityChangesViz1SubTitle.map(({ title }) => `${title}`)}
		/>

		<InView
			render={inView => (
				<RadialChart
					data={copy.personalityChangesViz1}
					includePercentage
					fill={'#709EEB'}
					secondHalfFill={'#ffffff'}
					keys={[50, 100]}
					max={100}
					degNum={'-45'}
					inView={inView}
					topTight
				/>
			)}
		/>
		<LookCloser />

		<InView
			render={inView => (
				<SliceChart
					data={copy.personalityChangesViz2}
					copy={copy.personalityChangesViz2Title}
					max={100}
					inView={inView}
					highlight={['Women', 'men']}
					highlightColors={['#17ADA1', '#B3F36C']}
				/>
			)}
		/>

		<InView
			render={inView => (
				<SliceChart
					data={copy.personalityChangesViz3}
					copy={copy.personalityChangesViz3Title}
					onRight
					max={100}
					inView={inView}
					highlight={['straight men', 'LGBTQ\\+']}
					highlightColors={['#86C93D', '#FECA98']}
				/>
			)}
		/>

		<ChartTitle tag="p" flush>
			{copy.personalityChangesViz4Title}
		</ChartTitle>

		<InView
			render={inView => (
				<EmojiGraphFaded
					data={copy.personalityChangesViz4}
					emoji={copy.personalityChangesViz4Emoji}
					inView={inView}
				/>
			)}
		/>

		<ChartTitle tag="p" flush>
			{copy.personalityChangesViz5Title}
		</ChartTitle>

		<InView
			render={inView => (
				<EmojiWordsGraph
					data={copy.personalityChangesViz5}
					isEnd
					inView={inView}
				/>
			)}
		/>
	</Chapter>
);

export default PersonalityChanges;



// WEBPACK FOOTER //
// ./components/PersonalityChanges/index.js